<div class="live-panel-title mt-2">
  Procalls <small>{{ getFilteredProcalls().length }} Open/Pending</small>
</div>
<div style="margin-top: 10px;"></div>
<input
  id="searchinput"
  class="listSearch form-control"
  type="text"
  [(ngModel)]="query"
  placeholder="Filter by procaller name"
  autofocus
  />

  <!-- Sort Dropdown -->
  <div class="btn-group" style="padding-top: 10px;">
    <button
      id="sort-procalls-button"
      type="button"
      class="btn live-panel-button dropdown-toggle p-1"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      >
      <i>Sort:</i> {{ toUpperCase(sortbyoption.replace('-', '')) }}
      <span class="caret" style="margin-left: 15px;"></span>
    </button>
    <ul class="dropdown-menu">
      @for (option of sortOptions; track option) {
        <li>
          <a class="dropdown-item" (click)="sortOptionClicked(option); $event.preventDefault();">{{ option }}</a>
        </li>
      }
    </ul>
  </div>

  <!-- Status Dropdown -->
  <div class="btn-group" style="padding-top: 10px; margin-left: 15px;">
    <button
      id="filter-procalls-button"
      type="button"
      class="btn live-panel-button dropdown-toggle p-1"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      >
      {{ statusOption }} <span class="caret" style="margin-left: 15px;"></span>
    </button>
    <ul class="dropdown-menu">
      @for (status of statusOptions; track status) {
        <li>
          <a class="dropdown-item" (click)="statusOptionClicked(status); $event.preventDefault();">{{ status }}</a>
        </li>
      }
    </ul>
  </div>

  <div style="margin-top: 10px;"></div>
  <div style="padding-bottom: 120px; padding-right: 10px; ">
    <!-- max-height: {{scrollHeight}}; overflow-y: auto; -->
    <table class="table table-striped table-hover" style="padding-top: 10px;">
      <tbody>
        @for (item of getFilteredProcalls(); track item) {
          <tr (click)="goToDevice(item)">
            <td>
              {{ item.getName() }}
              <br />
              {{ item.getFormattedCreatedAtDate() }}
            </td>
            <td>
              <button type="button" class="btn btn-info" (click)="getUserProfile($event,item)">
                <i class="glyphicon glyphicon-info-sign"></i>
              </button>
            </td>
            <td>
              <button type="button" class="btn btn-danger" (click)="goLiveProcall($event, item)">
                <i class="glyphicon glyphicon-globe"></i>
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>